import { ProductDoc } from '@gooduncles/gu-app-schema';
import { Switch, message, notification } from 'antd';
import { FC, useCallback, useState } from 'react';

import { parseIfObject } from 'src/utils/common';
import { updateProduct } from 'src/utils/firebase/firebase-short-cut';
import { AuditLogger } from 'src/utils/audit-logger';

const auditLogger = AuditLogger.getInstance();

type ProductToggleField = 'dailyNotification' | 'hidden';

interface AgCellProductSwitchEditorProps {
  productId: ProductDoc['_id'];
  value: boolean;
  field: ProductToggleField;
}

const AgCellProductSwitchEditor: FC<AgCellProductSwitchEditorProps> = ({ productId, value, field }) => {
  const [loading, setLoading] = useState(false);

  const handleSwitchChange = useCallback(
    async (value: boolean) => {
      setLoading(true);
      try {
        await updateProduct(productId, { [field]: value });
        message.success('변경완료.');
      } catch (error: any) {
        notification.error({
          message: '에러발생',
          description: error.message,
        });
        auditLogger.log({
          action: 'UPDATE',
          entity: 'product',
          entityId: productId,
          summary: `상품 관리 - product/${productId}.${field}:: ${parseIfObject(error)}`,
          level: 'error',
        });
      }
      setLoading(false);
    },
    [productId, field],
  );

  return <Switch loading={loading} checked={value} onChange={(v) => handleSwitchChange(v)} />;
};

export default AgCellProductSwitchEditor;
